import departmentsImpact from './displays-impact-departments'
import categoriesImpact from './displays-impact-categories'
import itemsImpact from './displays-impact-items'

export default {
  getSideEffects (displayId, menuBlob) {
    return [
      ...departmentsImpact.getSideEffects(displayId, menuBlob),
      ...categoriesImpact.getSideEffects(displayId, menuBlob),
      ...itemsImpact.getSideEffects(displayId, menuBlob)
    ]
  },
  applySideEffects (displayId, menuBlob) {
    departmentsImpact.applySideEffects(displayId, menuBlob)
    categoriesImpact.applySideEffects(displayId, menuBlob)
    itemsImpact.applySideEffects(displayId, menuBlob)
  }
}
